import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

interface IRevealProps {
    children: React.ReactNode;
    delay?: number;
    className?: string;
}

export default function Reveal({ children, delay = 0, className }: IRevealProps) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, delay, ease: 'easeOut' }}
        >
            {children}
        </motion.div>
    );
}
